<template>
  <Modal :open="isOpen" @close="closeSellerUpdateModal">
    <VeeForm v-slot="{ handleSubmit }" :validation-schema="schema" as="div">
      <form class="space-y-4" @submit="handleSubmit($event, updateSeller)" ref="saleCreationForm">
        <div class="grid grid-cols-2 gap-x-4 gap-y-3">
          <div class="flex-1">
            <label for="firstName" class="block text-sm text-gray-700">
              Prénom
              <span class="ml-1 text-red-600">*</span>
            </label>
            <Field
              type="text"
              name="localSeller.firstName"
              id="firstName"
              autocomplete="given-name"
              class="shadow-xs focus:ring-primary focus:border-primary block w-full sm:text-sm border-gray-300 rounded-md"
              placeholder="John"
              v-model="localSeller.firstName"
            />
            <ErrorMessage name="localSeller.firstName" class="mt-2 text-sm text-red-600" />
          </div>
          <div class="flex-1">
            <label for="lastName" class="block text-sm text-gray-700">Nom</label>
            <Field
              type="text"
              name="localSeller.lastName"
              id="lastName"
              autocomplete="family-name"
              class="shadow-xs focus:ring-primary focus:border-primary block w-full sm:text-sm border-gray-300 rounded-md"
              placeholder="Doe"
              v-model="localSeller.lastName"
            />
            <ErrorMessage name="localSeller.lastName" class="mt-2 text-sm text-red-600" />
          </div>
          <div class="flex-1">
            <label for="email" class="block text-sm text-gray-700">
              {{ $t("Email") }}
            </label>
            <div class="mt-1">
              <Field
                id="email"
                name="localSeller.email"
                type="email"
                class="shadow-xs focus:ring-primary focus:border-primary block w-full sm:text-sm border-gray-300 rounded-md"
                v-model="localSeller.email"
              />
              <ErrorMessage name="localSeller.email" class="mt-2 text-sm text-red-600" />
            </div>
          </div>
          <div class="flex-1">
            <label for="phone" class="block text-sm text-gray-700">
              {{ $t("Phone number") }}
            </label>
            <div class="mt-1">
              <Field
                id="phone"
                name="localSeller.phone"
                type="tel"
                class="shadow-xs focus:ring-primary focus:border-primary block w-full sm:text-sm border-gray-300 rounded-md"
                placeholder="+33 6 99 49 75 90"
                v-model="localSeller.phone"
              />
              <ErrorMessage name="localSeller.phone" class="mt-2 text-sm text-red-600" />
            </div>
          </div>
        </div>
        <div class="flex justify-center">
          <div>
            <button
              class="border border-transparent text-button-font-primary bg-primary px-4 py-2 text-sm font-medium uppercase transition duration-300 transform hover:scale-105 rounded-lg focus:outline-hidden"
              type="submit"
            >
              {{ $t("Complete") }}
            </button>
          </div>
        </div>
      </form>
    </VeeForm>
  </Modal>
</template>

<script>
import { Modal, phoneRegex } from "@estaly/ui";
import { Form as VeeForm, Field, ErrorMessage } from "vee-validate";
import * as yup from "yup";
import { mapActions } from "vuex";

export default {
  components: {
    Modal,
    VeeForm,
    Field,
    ErrorMessage,
  },

  props: {
    isOpen: Boolean,
    selectedSeller: Object,
  },

  emits: ["getSellers", "closeSellerUpdate"],

  data: () => {
    const schema = yup.object({
      localSeller: yup.object({
        firstName: yup.string().required("Le prénom du vendeur est requis."),
        email: yup.string().nullable(),
        phone: yup
          .string()
          .nullable()
          .matches(
            phoneRegex,
            "Le numéro de téléphone n'est pas valide pour la France ou les départements d'outre-mer.",
          ),
      }),
    });

    return {
      schema,
      localSeller: {
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
      },
    };
  },

  watch: {
    selectedSeller: {
      handler(newValue) {
        if (newValue) {
          this.localSeller = { ...newValue };
        }
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
    ...mapActions("notifications", ["notify"]),
    ...mapActions("sellers", ["update"]),

    closeSellerUpdateModal() {
      this.$emit("closeSellerUpdate");
    },

    async updateSeller() {
      const response = await this.update({
        id: this.selectedSeller.id,
        data: this.localSeller,
      });
      if (!response?.success) return;

      this.$emit("getSellers");
      this.closeSellerUpdateModal();
    },
  },
};
</script>
